/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { PaymentOpsPaymentEventDto } from './PaymentOpsPaymentEventDto';
import {
    PaymentOpsPaymentEventDtoFromJSON,
    PaymentOpsPaymentEventDtoFromJSONTyped,
    PaymentOpsPaymentEventDtoToJSON,
    PaymentOpsPaymentEventDtoToJSONTyped,
} from './PaymentOpsPaymentEventDto';

/**
 * 
 * @export
 * @interface NonCapturedPaymentDto
 */
export interface NonCapturedPaymentDto {
    /**
     * 
     * @type {number}
     * @memberof NonCapturedPaymentDto
     */
    paymentId: number;
    /**
     * 
     * @type {string}
     * @memberof NonCapturedPaymentDto
     */
    paymentReference: string;
    /**
     * 
     * @type {NonCapturedPaymentDtoLatestStateEnum}
     * @memberof NonCapturedPaymentDto
     */
    latestState?: NonCapturedPaymentDtoLatestStateEnum;
    /**
     * 
     * @type {NonCapturedPaymentDtoLatestEventCodeEnum}
     * @memberof NonCapturedPaymentDto
     */
    latestEventCode: NonCapturedPaymentDtoLatestEventCodeEnum;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof NonCapturedPaymentDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {NonCapturedPaymentDtoPaymentMethodEnum}
     * @memberof NonCapturedPaymentDto
     */
    paymentMethod: NonCapturedPaymentDtoPaymentMethodEnum;
    /**
     * 
     * @type {Array<PaymentOpsPaymentEventDto>}
     * @memberof NonCapturedPaymentDto
     */
    events: Array<PaymentOpsPaymentEventDto>;
    /**
     * 
     * @type {number}
     * @memberof NonCapturedPaymentDto
     */
    executingLocationId: number;
    /**
     * 
     * @type {Date}
     * @memberof NonCapturedPaymentDto
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof NonCapturedPaymentDto
     */
    updated: Date;
    /**
     * 
     * @type {boolean}
     * @memberof NonCapturedPaymentDto
     */
    canExcludeFromWashing: boolean;
}


/**
 * @export
 */
export const NonCapturedPaymentDtoLatestStateEnum = {
    INITIATING: 'INITIATING',
    AWAITING_PAYMENT: 'AWAITING_PAYMENT',
    AUTHORISING: 'AUTHORISING',
    AUTHORISED: 'AUTHORISED',
    CAPTURING: 'CAPTURING',
    CAPTURED: 'CAPTURED',
    PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
    FULLY_REFUNDED: 'FULLY_REFUNDED',
    FAILED: 'FAILED',
    UNKNOWN: 'UNKNOWN',
    REFUNDING: 'REFUNDING'
} as const;
export type NonCapturedPaymentDtoLatestStateEnum = typeof NonCapturedPaymentDtoLatestStateEnum[keyof typeof NonCapturedPaymentDtoLatestStateEnum];

/**
 * @export
 */
export const NonCapturedPaymentDtoLatestEventCodeEnum = {
    INITIATE: 'INITIATE',
    INITIATE_FAILED: 'INITIATE_FAILED',
    SEND_FOR_PAYMENT: 'SEND_FOR_PAYMENT',
    REDIRECT_SHOPPER: 'REDIRECT_SHOPPER',
    PAYMENT_CANCELLED: 'PAYMENT_CANCELLED',
    COMPLETE_WITHOUT_PAYMENT: 'COMPLETE_WITHOUT_PAYMENT',
    AUTHORISE: 'AUTHORISE',
    AUTHORISE_FAILED: 'AUTHORISE_FAILED',
    AUTHORISE_SUCCEEDED: 'AUTHORISE_SUCCEEDED',
    CAPTURE: 'CAPTURE',
    CAPTURE_SUCCEEDED: 'CAPTURE_SUCCEEDED',
    CAPTURE_FAILED: 'CAPTURE_FAILED',
    REFUND: 'REFUND',
    REFUND_SUCCEEDED: 'REFUND_SUCCEEDED',
    REFUND_FAILED: 'REFUND_FAILED',
    STATE_UNDETERMINED: 'STATE_UNDETERMINED',
    STATE_IN_PROGRESS: 'STATE_IN_PROGRESS',
    MANUAL_STATE_OVERRIDE: 'MANUAL_STATE_OVERRIDE'
} as const;
export type NonCapturedPaymentDtoLatestEventCodeEnum = typeof NonCapturedPaymentDtoLatestEventCodeEnum[keyof typeof NonCapturedPaymentDtoLatestEventCodeEnum];

/**
 * @export
 */
export const NonCapturedPaymentDtoPaymentMethodEnum = {
    CARD: 'CARD',
    VIPPS: 'VIPPS',
    APPLE_PAY: 'APPLE_PAY',
    MOBILE_PAY: 'MOBILE_PAY',
    GOOGLE_PAY: 'GOOGLE_PAY',
    SWISH: 'SWISH',
    INTEGRATED_TERMINAL: 'INTEGRATED_TERMINAL',
    MOBILE_CARD_TERMINAL: 'MOBILE_CARD_TERMINAL',
    INVOICE: 'INVOICE',
    CASH: 'CASH',
    FREE: 'FREE',
    BILL_ON_ROOM: 'BILL_ON_ROOM'
} as const;
export type NonCapturedPaymentDtoPaymentMethodEnum = typeof NonCapturedPaymentDtoPaymentMethodEnum[keyof typeof NonCapturedPaymentDtoPaymentMethodEnum];


/**
 * Check if a given object implements the NonCapturedPaymentDto interface.
 */
export function instanceOfNonCapturedPaymentDto(value: object): value is NonCapturedPaymentDto {
    if (!('paymentId' in value) || value['paymentId'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('latestEventCode' in value) || value['latestEventCode'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('events' in value) || value['events'] === undefined) return false;
    if (!('executingLocationId' in value) || value['executingLocationId'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('updated' in value) || value['updated'] === undefined) return false;
    if (!('canExcludeFromWashing' in value) || value['canExcludeFromWashing'] === undefined) return false;
    return true;
}

export function NonCapturedPaymentDtoFromJSON(json: any): NonCapturedPaymentDto {
    return NonCapturedPaymentDtoFromJSONTyped(json, false);
}

export function NonCapturedPaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NonCapturedPaymentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentId': json['paymentId'],
        'paymentReference': json['paymentReference'],
        'latestState': json['latestState'] == null ? undefined : json['latestState'],
        'latestEventCode': json['latestEventCode'],
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentMethod': json['paymentMethod'],
        'events': ((json['events'] as Array<any>).map(PaymentOpsPaymentEventDtoFromJSON)),
        'executingLocationId': json['executingLocationId'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'canExcludeFromWashing': json['canExcludeFromWashing'],
    };
}

export function NonCapturedPaymentDtoToJSON(json: any): NonCapturedPaymentDto {
    return NonCapturedPaymentDtoToJSONTyped(json, false);
}

export function NonCapturedPaymentDtoToJSONTyped(value?: NonCapturedPaymentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentId': value['paymentId'],
        'paymentReference': value['paymentReference'],
        'latestState': value['latestState'],
        'latestEventCode': value['latestEventCode'],
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentMethod': value['paymentMethod'],
        'events': ((value['events'] as Array<any>).map(PaymentOpsPaymentEventDtoToJSON)),
        'executingLocationId': value['executingLocationId'],
        'created': value['created'].toISOString(),
        'updated': value['updated'].toISOString(),
        'canExcludeFromWashing': value['canExcludeFromWashing'],
    };
}

